/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { useAtomValue } from 'jotai'
import React from 'react'
import { ActivityPreviewCard } from '@/components/dashboard/manuals/ui/ActivityPreviewCard'
import { Alert } from '@/components/ui/Alert'
import { ManualActivityPreviewCardStoryblok } from '@/lib/storyblok/types/generated-types'
import {
  findActivityAndModuleByActivityStoryblokId,
  manualAtom,
  StoryblokActivityWithParentModule,
} from '@/store/manual'

/** A description of the available properties for this component. */
type ModuleActivityPreviewCardProps = {
  blok: ManualActivityPreviewCardStoryblok
}

/**
 * Storyblok wrapper for the base {@link ActivityPreviewCard} component.
 */
const StoryblokModuleActivityPreviewCard: React.FC<ModuleActivityPreviewCardProps> = ({ blok }) => {
  const manual = useAtomValue(manualAtom)
  const { activity: activity_array } = blok
  let storyblokManualData: StoryblokActivityWithParentModule | null = null

  if (!activity_array || !activity_array.length) {
    return <Alert type={'error'} message={'Error with activity preview card.'} />
  }

  if (typeof activity_array[0] === 'string') {
    storyblokManualData = useAtomValue(findActivityAndModuleByActivityStoryblokId(activity_array[0]))
  }

  if (!storyblokManualData || !manual) {
    return <Alert type={'error'} message={'Error finding manual/activity.'} />
  }

  const { activity, module } = storyblokManualData

  return <ActivityPreviewCard kit={manual.kit} module={module} activity={activity} />
}

export { StoryblokModuleActivityPreviewCard }
